import { createReducer } from '@reduxjs/toolkit';
import {
    SET_PLAYLIST_TRACKS,
    SET_PLAYLIST_TYPE,
    SET_CURRENT_TRACK,
} from '../actions/PlaylistActions';

// @TODO create an ADD_ as this and SET are two different things.
// The SET_ can be a reset too in future changes.
// by now we just set an array, which the music to play is located, into trackList
// this is a "playAll" function, but we need a "playThis" function, which add only
// the requested song.

const initialState = {
    playlistType: '',
    trackList: [],
    currentIndex: false,
    currentMusicId: false,
};

const playlist = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_PLAYLIST_TYPE, (state, action) => {
            state.playlistType = action.playlistType;
        })
        .addCase(SET_PLAYLIST_TRACKS, (state, action) => {
            state.trackList = action.trackList;
        })
        .addCase(SET_CURRENT_TRACK, (state, action) => {
            state.currentIndex = action.currentIndex;
            state.currentMusicId = action.currentMusicId;
        });
});

export default playlist;
